__turbopack_context__.v({
  "chipList": "EventFacts-module-scss-module__d6K4Mq__chipList",
  "chipListBreak": "EventFacts-module-scss-module__d6K4Mq__chipListBreak",
  "icon": "EventFacts-module-scss-module__d6K4Mq__icon",
  "iconWithText": "EventFacts-module-scss-module__d6K4Mq__iconWithText",
  "label": "EventFacts-module-scss-module__d6K4Mq__label",
});
